import React, { Component } from 'react';
import { Col, Row, Button } from 'antd';
import { Translation } from 'react-i18next';

class ContactComponent extends Component {
  render() {
    return (
      <Translation>
        {(t) => (
          <div className="landing__contact pb-medium">
            <h2 className="landing__contact-header pb-medium">
              {t('landing.contact_us')}
            </h2>
            <div className="f-center">
              <div className="landing__contact-list" span={8}>
                <img src={require('../assets/imgs/image6.png')} alt="" className="landing__contact-item-img" />
                <h3 className="landing__contact-item-header">
                  {t('landing.support_24_7')}
                </h3>
                <p className="landing__contact-item-text">
                  {t('landing.problem')}
                </p>
              </div>
              <div className="landing__contact-list" span={8}>
                <img src={require('../assets/imgs/image7.png')} alt="" className="landing__contact-item-img" />
                <h3 className="landing__contact-item-header">
                  {t('landing.blog')}
                </h3>
                <p className="landing__contact-item-text">
                  {t('landing.news')}
                </p>
              </div>
              <div className="landing__contact-list" span={8}>
                <img src={require('../assets/imgs/image8.png')} alt="" className="landing__contact-item-img" />
                <h3 className="landing__contact-item-header">
                  {t('landing.community')}
                </h3>
                <p className="landing__contact-item-text">
                  {t('landing.join_us')}
                </p>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default ContactComponent;
